import script from "./P5Canvas.vue?vue&type=script&setup=true&lang=js"
export * from "./P5Canvas.vue?vue&type=script&setup=true&lang=js"

import "./P5Canvas.vue?vue&type=style&index=0&id=2a77ceaa&lang=css"

const __exports__ = script;

export default __exports__